// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { Call } from '@azure/communication-calling';

/**
 * Connects call automation to an existing group call
 * @param serverCallId - The server call ID from the established call
 * @returns Promise that resolves when call automation is connected
 */
export const connectCallAutomationToGroupCall = async (call: Call, interviewRef: string): Promise<boolean> => {
  if (!interviewRef) {
    throw new Error('interviewRef is not set');
  }
  if (call.info !== undefined && call.state === 'Connected') {
    const serverCallID = await call.info.getServerCallId();
    const payload = { serverCallId: serverCallID, interviewRef };
    const response = await fetch('/joinGroupCallWithAutomation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      if (response.status === 401) {
        window.dispatchEvent(new CustomEvent('auth-unauthorized'));
        throw new Error('Unauthorized');
      }
      throw new Error('Failed to start call with call automation: ' + response.statusText);
    }
    return true;
  }
  return false;
};
